import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const bannerStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.5em',
    padding: '0.75em 1em',
    borderRadius: '0.375rem',
    border: '1px solid #cf222e',
    background: '#fff5f5',
    color: '#86181d',
    font: 'inherit',
};
const dismissStyle = {
    marginLeft: 'auto',
    background: 'transparent',
    border: 'none',
    color: 'inherit',
    font: 'inherit',
    fontSize: '1.1em',
    lineHeight: 1,
    cursor: 'pointer',
    padding: '0 0.25em',
};
/** Renders an assertive error banner with an optional title and dismiss button. */
export function ErrorBanner({ children, title, onDismiss, dismissLabel = 'Dismiss', className, }) {
    return (_jsxs("div", { role: "alert", className: className, style: bannerStyle, children: [_jsx("span", { "aria-hidden": "true", children: "\u26A0" }), _jsxs("div", { children: [title !== undefined ? _jsx("strong", { style: { display: 'block' }, children: title }) : null, _jsx("span", { children: children })] }), onDismiss ? (_jsx("button", { type: "button", "aria-label": dismissLabel, onClick: onDismiss, style: dismissStyle, children: "\u00D7" })) : null] }));
}
//# sourceMappingURL=ErrorBanner.js.map